import { Component } from '@angular/core';

@Component({
  selector: 'app-institutional-session24',
  templateUrl: './institutional-session24.component.html',
  styleUrl: './institutional-session24.component.css'
})
export class InstitutionalSession24Component {

}
